// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timer_wrapper__ws8sQ {
  margin-right: auto;
}

.timer_wrapper__ws8sQ span {
  font-size: 16px;
  line-height: 20px;
  color: var(--overlayForeground);
  opacity: 0.999999;
}

.timer_wrapper__ws8sQ > *:nth-child(2) {
  margin-left: 5px;
  opacity: 0.7;
}
`, "",{"version":3,"sources":["webpack://./src/components/timer/timer.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd","sourcesContent":[".wrapper {\n  margin-right: auto;\n}\n\n.wrapper span {\n  font-size: 16px;\n  line-height: 20px;\n  color: var(--overlayForeground);\n  opacity: 0.999999;\n}\n\n.wrapper > *:nth-child(2) {\n  margin-left: 5px;\n  opacity: 0.7;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `timer_wrapper__ws8sQ`
};
export default ___CSS_LOADER_EXPORT___;
